import type { QuotaDuplicateEntities, productShopEntities } from "../entities/ProductGroupEntity";

interface GroupedQuota {
  quotaId: string;
  quotaName: string;
  startDate: string;
  quotaType: string;
  endDate: string;
  customers: {
    customerCompanyId: number;
    customerName: string;
    customerNo: string;
    customerZone: string;
    customerGroup: string;
    products: productShopEntities[];
  }[];
}

export function groupByCustomerCompanyId(quotas: QuotaDuplicateEntities[]): GroupedQuota[] {
  return quotas.map((quota) => {
    const customerMap = new Map<number, GroupedQuota["customers"][number]>();

    quota.productShop.forEach((item) => {
      const companyId = item.customerCompanyId;

      if (!customerMap.has(companyId)) {
        customerMap.set(companyId, {
          customerCompanyId: item.customerCompanyId,
          customerName: item.customerName,
          customerNo: item.customerNo,
          customerZone: item.customerZone,
          customerGroup: item.customerGroup,
          products: [],
        });
      }

      const customerEntry = customerMap.get(companyId)!;
      customerEntry.products.push(item);
    });

    return {
      quotaId: quota.quotaId,
      quotaName: quota.quotaName,
      startDate: quota.startDate,
      endDate: quota.endDate,
      quotaType: quota.quotaType,
      customers: Array.from(customerMap.values()),
    };
  });
}
